// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"CookieConsentBanner_snackbar__XLL0J","leaving":"CookieConsentBanner_leaving___lFRk","text":"CookieConsentBanner_text__E1dM_","close":"CookieConsentBanner_close__F78wS"};